<template>
  <v-container>
    <v-form ref="form" v-model="validForm">
      <v-row>
        <v-col cols="12" class="pb-md-0">
          <v-row class="mt-3 mt-md-1">
            <v-col>
              <v-text-field
                required
                color="#979797"
                class="to"
                label="Destinatario(s)"
                v-model="mail.toAsString"
                :rules="toRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-text-field color="#979797" class="cc" label="Cc" v-model="mail.ccString"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-text-field
                required
                color="#979797"
                class="subject"
                label="Asunto"
                v-model="mail.subject"
                :rules="subjectRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-text-field
                required
                color="#979797"
                class="body"
                label="Cuerpo"
                v-model="mail.body"
                :rules="bodyRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-btn
                block
                large
                class="float-right"
                @click="mailDocumento"
                color="secondary"
                :loading="loading"
                :disabled="!validForm"
              >
                <v-icon left>mdi-mail</v-icon>Enviar por correo
              </v-btn>
            </v-col>
          </v-row>

          <v-alert prominent v-show="exitoVisible" type="success" class="mb-md-0">
            <v-row align="center">
              <v-col class="grow">Documento firmado enviado.</v-col>
              <v-col class="shrink">
                <v-btn v-on:click="dismissOk">Ok</v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-alert prominent v-show="falloVisible" type="error" class="mb-md-0">
            <v-row align="center">
              <v-col class="grow">
                El documento no pudo ser enviado
                {{ validacionCorreos }}
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import Vue from "vue";
import MailService from "../services/mailService";

function stringToMailArray(mailString) {
  return mailString.split(",").map(function(mail) {
    return mail.trim();
  });
}

export default Vue.extend({
  props: {
    documento: String
  },
  data: function() {
    return {
      exitoVisible: false,
      falloVisible: false,
      validForm: true,
      loading: false,
      lazyValidation: true,
      validacionCorreos: "",
      mail: {
        toAsString: "",
        to: [],
        ccString: "",
        cc: [],
        subject: "Nuevo documento Firmado",
        body: "Se adjunta documento firmado"
      },
      toRules: [v => !!v || "Debe ingresar uno o más destinarios"],
      subjectRules: [v => !!v || "Debe ingresar un asunto"],
      bodyRules: [v => !!v || "Debe ingresar un mensaje"]
    };
  },
  methods: {
    dismissOk: function() {
      this.exitoVisible = false;
    },
    mostrarFallo: function() {
      this.exitoVisible = false;
      this.falloVisible = true;
    },
    mostrarExito: function() {
      this.exitoVisible = true;
      this.falloVisible = false;
    },
    mailDocumento: async function() {
      console.log("Enviando documento firmado");
      this.mail.to = stringToMailArray(this.mail.toAsString);
      this.mail.cc = stringToMailArray(this.mail.ccString);
      try {
        let result = await MailService.mailDocumento(this.documento, this.mail);
        console.log(result);
        if (result) {
          this.mostrarExito();
        }
      } catch (error) {
        console.log(error);
        this.validacionCorreos =
          ": " +
          error.data.errors
            .map(
              validacion =>
                `${validacion.rejectedValue} ${validacion.defaultMessage}`
            )
            .join(", ");
        this.mostrarFallo();
      }
    }
  }
});
</script>

<style lang="scss">
$weight: 200;
.to,
.cc,
.subject,
.body {
  font-weight: $weight;
}
</style>
